import {Mapper} from '@s-ui/domain'

/**
 * @implements Mapper
 */
export class TrackingPublishMyAdMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   */
  constructor({config, fromPageTrackingJsonToTrackingDataValueObjectMapper}) {
    super()

    this._config = config
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {String} param.data.plateVehicleSelected
   * @param {String} param.data.withPlateStatus
   */
  map({page, culture, data}) {
    const {plateVehicleSelected, withPlateStatus} = data

    const trackingData = {}

    if (plateVehicleSelected) {
      trackingData.search_result_number = Number(plateVehicleSelected) + 1
    }

    const hitInformationList = {
      plateRecommendedPrice: 'matricula es mi coche',
      plateEditField: 'matricula corregir dato',
      plateListNotMyCar: 'matricula mi coche no sale en la lista',
      plateNotMyCar: 'matricula no es mi coche',
      plateSkip: 'matricula skip'
    }

    const hitInformation = hitInformationList[withPlateStatus]

    if (hitInformation) {
      trackingData.hit_information = hitInformation
    }

    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({
        page,
        culture
      })
      .map(trackingData)
  }
}
